export default "__VITE_ASSET__D$47RFFs__"